import { decodeBase64Unicode } from "./base64";

class UnsafeJwtToken {
  constructor(
    public readonly header: Record<string, any>,
    // keep private to force use of ts-expect-error
    private readonly unsafe_payload: Record<string, any>
  ) {}
}

const decodeBaseJwtPart = (part: string): Record<string, any> =>
  JSON.parse(decodeBase64Unicode(part));

/**
 * This method doesn't validate JWT signatures and should be used with caution.
 * @param token The token to parse
 */
export function unsafeDecodeJwtPayload(token: string): UnsafeJwtToken | null {
  const parts = token.split(".");
  if (parts.length !== 3) {
    return null;
  }
  const header = decodeBaseJwtPart(parts[0]);
  const payload = decodeBaseJwtPart(parts[1]);
  return new UnsafeJwtToken(header, payload);
}
